import ImageGallery from '../classes/ImageGallery';

$(document).ready(function() {
   $('.image-gallery').each(function () {
       ImageGallery.init($(this));
   });
});